// store/thunks/auth/resendEmailCodeThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { VerificationDTO } from '@/types/DTOs';

export const resendEmailCodeThunk = createAppAsyncThunk<
  VerificationDTO,
  undefined,
  { rejectValue: { message: string } }
>(
  'auth/resendEmailCode',
  async(_, { extra: { authService }, rejectWithValue }) => {

    try {
      return await authService.resendEmailCode();
    } catch (caught) {
      const message =
        caught instanceof Error ? caught.message : 'Failed to resend email code';
      return rejectWithValue({ message });
    }
  }
);
